import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { businessMapping } from '../../../services/businessMapping';
import { productHeadingInfo, productSubHeadingInfo } from './ProductHeadingStyles';
import Header from '../../../WebComponents/components/Header';
import { isWebComponentFlow } from '../../commonCode';
// import { ProductHeadingStyles } from './ProductHeadingStyles';

export const ProductHeading = ({ productName, stepDescription, id, ariaDescribedbyId }) => {
  // const classes = ProductHeadingStyles();
  const baseContext = isWebComponentFlow();

  const changeProductNmIncomingRTT = () => {
    let product;
    if (businessMapping(productName) && baseContext.language === 'EN') {
      switch (productName) {
        case 'Prestamo Comercial':
          product = 'Commercial Loan';
          break;
        case 'Tarjeta de Credito Comercial':
          product = 'Commercial Credit Card';
          break;

        case 'Linea de Credito Comercial':
          product = 'Commercial Line of Credit';
          break;

        case 'CD Comercial':
          product = 'Commercial CD';
          break;

        case 'SIN FINES DE LUCRO':
          product = 'NON-PROFIT';
          break;

        default:
          product = productName;
      }
    } else {
      switch (productName) {
        case 'Prestamo Comercial':
          product = 'Préstamo Comercial';
          break;
        case 'Tarjeta de Credito Comercial':
          product = 'Tarjeta de Crédito Comercial';
          break;

        case 'Linea de Credito Comercial':
          product = 'Línea de Crédito Comercial';
          break;

        case 'CD Comercial':
          product = 'Comercial CD';
          break;

        case 'SIN FINES DE LUCRO':
          product = 'SIN FINES DE LUCRO';
          break;

        default:
          product = productName;
      }
    }
    return product;
  };

  return (
    <>
      {baseContext?.wcFlow && (
        <Box
          sx={{
            marginLeft: '-36px',
            '@media (max-width:600px)': { marginLeft: '-14px' },
          }}
        >
          <Header />
        </Box>
      )}
      <Typography
        id={id}
        data-testid="heading_testid"
        role="heading"
        variant="h2"
        component="h2"
        sx={{
          ...productHeadingInfo,
          ...(baseContext?.wcFlow && {
            '@media (min-width:600px)': {
              margin: '-9px -35px 12px -35px',
              width: '100%',
              background: '#F5821F',
              color: '#FFFFFF',
              padding: '16px 35px',
            },
          }),
        }}
      >
        {businessMapping(productName) ? changeProductNmIncomingRTT() : productName}
      </Typography>
      <Typography
        id={ariaDescribedbyId}
        data-testid="desc_testid"
        variant="subtitle1"
        component="h6"
        role="heading"
        aria-label={stepDescription}
        sx={productSubHeadingInfo}
      >
        {stepDescription}
      </Typography>
    </>
  );
};

ProductHeading.propTypes = {
  productName: PropTypes.string,
  stepDescription: PropTypes.string,
  id: PropTypes.string,
  ariaDescribedbyId: PropTypes.string,
};
